import { PLATFORM } from '../platformConstants';
import viewNavConfig from './NavItems.json';
import viewIconMap from './IconMap';
import MenuBottom from './MenuBottom';

export const CURRENT_PLATFORM = PLATFORM.VIEW;

const viewProvider = {
	platformId: CURRENT_PLATFORM,
	getCurrentPlatform: () => CURRENT_PLATFORM,
	getNavConfig: () => viewNavConfig,
	getIconMap: () => viewIconMap,
	getMenuBottom: () => MenuBottom
};

export default viewProvider;
